var _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _ellipse2, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    fill: "#746C20",
    fillOpacity: 0.23
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.0133,
    cy: 75.9998,
    r: 70.1539,
    fill: "#746C20",
    fillOpacity: 0.439216
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.0397,
    cy: 72.4918,
    r: 58.4616,
    fill: "#746C20",
    fillOpacity: 0.439216
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.6154,
    cy: 66.5055,
    r: 52.6154,
    fill: "#746C20",
    fillOpacity: 0.439216
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.7693,
    cy: 66.6594,
    r: 46.7693,
    fill: "#746C20",
    fillOpacity: 0.439216
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.0769,
    cy: 63.8132,
    rx: 35.0769,
    ry: 40.9231,
    fill: "#746C20",
    fillOpacity: 0.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3846,
    cy: 55.1722,
    rx: 23.3846,
    ry: 27.2821,
    fill: "#746C20",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2023_23740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5385,
    cy: 49.4286,
    r: 17.5385,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2023_23740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.6923,
    cy: 47.5825,
    r: 11.6923,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2023_23740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.7692,
    cy: 44.6594,
    r: 8.76924,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2023_23740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.8462,
    cy: 43.7363,
    r: 5.84616,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2023_23740",
    x: 66,
    y: 27.8901,
    width: 43.0781,
    height: 43.0769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2023_23740",
    x: 72,
    y: 31.8901,
    width: 31.3828,
    height: 31.3846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2023_23740",
    x: 75,
    y: 31.8901,
    width: 25.5391,
    height: 25.5385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2023_23740",
    x: 78,
    y: 33.8901,
    width: 19.6914,
    height: 19.6923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23740"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowcircle);
export default __webpack_public_path__ + "static/media/Yellow circle.b5953dbd7d4fa1efb8d93bf30c73d233.svg";
export { ForwardRef as ReactComponent };